<template>
  <div class="toolbox">
    <a href="#" @click.prevent="backDir" v-if="cwd.folder != 'Root'"><i class="fas fa-arrow-left fa-fw" />Back</a>
    <a href="#" v-if="user && user.superuser" @click.prevent="showNewFolder"><i class="fas fa-plus fa-fw" />New Folder</a>
    <a href="#" v-if="user && user.superuser" @click.prevent="showUpload"><i class="fas fa-file-upload fa-fw" />Upload File</a>
    <span class="vbar"></span>
    
    <!-- <i class="fas fa-sort"></i> -->
    <select v-model="sorting" @change="updateSorting">
      <option value>Default (A-Z)</option>
      <option value="display_name.desc">Z-A</option>
      <option value="created.desc">Newest First</option>
      <option value="created.asc">Oldest First</option>
    </select>

    <modal ref="folder">
    <h4>New Folder</h4>
    <form @submit.prevent="saveFolder">
      <p>
      <label>Folder Name
        <input autofocus type="text" name="folder_name" v-model="folderName" />
      </label>
      </p>
      <p>
      <button>OK</button>
      <button class="cancel" type="button" @click.prevent="$refs.folder.close()">Cancel</button>
      </p>
    </form>
    </modal>

    <modal ref="upload">
    <upload :path="cwd.folder" @finished="fileUploaded" />
    </modal>
  </div>
</template>
<script>
import axios from 'axios'
import {mapState} from 'vuex'

import Modal from './Modal.vue'
import Upload from './Upload.vue'

const displayToFolder = name => {
  let n = name.replace(/[^a-zA-Z0-9_ ]/g, '')
  return n.replace(/\s+/g, '_')
}

export default {
  name: 'Toolbox',
  components: {Modal, Upload},
  data() {
    return {
      folderName: '',
      publicFolder: false,
      searchtext: '',
      sorting: '',
    }
  },
  computed: {
    ...mapState(['cwd', 'user', 'sortMethod'])
  },
  methods: {
    updateSorting() {
      this.$nextTick(() => {
        this.$store.dispatch('setSortMethod', this.sorting)
        this.$emit('update-sorting', this.sorting)
      })
    },
    showNewFolder() {
      this.$refs.folder.showModal()
    },
    showUpload() {
      this.$refs.upload.showModal()
    },
    saveFolder() {
      this.$emit('save-folder', {folderName: this.folderName, publicFolder: this.publicFolder})
      this.$refs.folder.close()
      this.folderName = ''
    },
    fileUploaded(info) {
      this.$emit('refresh-items')
      this.$refs.upload.close()
    },
    async backDir() {
      let r = await axios.get(`/api/files/get-parent/${this.cwd.id}`, {
        params: {
          fields: 'id,folder',
        }
      })

      if (r.status != 200) {
        return;
      }

      if (r.data.file == null) {
        this.$router.push('/')
      }
      else {
        this.$router.push(`/${r.data.file.id}`)
      }
    },
    handleShortcut(event) {
      if (event.altKey && event.key == 'n') {
        // console.log('ok')
        this.$refs.folder.showModal();
      }
    },
  },
  mounted() {
    this.sorting = this.sortMethod
    document.addEventListener('keydown', this.handleShortcut)
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleShortcut)
  },
}
</script>
<style lang="scss">
@import '../scss/_include-media.scss';

.toolbox {
  background: #f0f0f0;
  display: inline-flex;
  align-items: center;

  .vbar {
    display: block;
    width: 1px;
    height: auto;
    background: #0C6A38;
    align-self: stretch;
    margin: 6px 1rem 6px 0.5rem;
  }

  select {
    box-sizing: border-box;
    margin: 0 0.25rem;
  }

  a {
    padding: 10px;
    text-align: center;
  }

  dialog {
    // border-radius: 4px;

    button {
      padding: 0.5rem 1rem;

      &:first-child {
        margin-right: 1rem;
      }
    }
  }
}
</style>
